import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Shield, Users, Award } from 'lucide-react';
import { mockData } from '../mockData';
import { scrollToSection } from '../lib/scroll';

const heroFeatures = [
  { icon: Shield, label: 'Rigor Técnico' },
  { icon: Users, label: 'Proximidade' },
  { icon: Award, label: 'Experiência' }
];

const HeroFeatures = () => (
  <div className="grid grid-cols-3 gap-6 pt-8 border-t border-navy/10">
    {heroFeatures.map(({ icon: Icon, label }) => (
      <div key={label} className="text-center space-y-2">
        <div className="w-12 h-12 bg-gold/10 rounded-full flex items-center justify-center mx-auto">
          <Icon className="w-6 h-6 text-gold" />
        </div>
        <div className="text-sm font-semibold text-navy">{label}</div>
      </div>
    ))}
  </div>
);

const HeroActions = () => (
  <div className="flex flex-col sm:flex-row gap-4">
    <Button
      onClick={() => scrollToSection('contact')}
      data-testid="hero-cta-button"
      className="bg-navy hover:bg-navy/90 text-white px-8 py-6 text-lg rounded-sm transition-all duration-300 hover:shadow-xl group"
    >
      Agendar Consulta
      <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
    </Button>
    <Button
      onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
      variant="outline"
      data-testid="hero-learn-more-button"
      className="border-2 border-navy text-navy hover:bg-navy hover:text-white px-8 py-6 text-lg rounded-sm transition-all duration-300"
    >
      Saber Mais
    </Button>
  </div>
);

const HeroImage = () => (
  <div className="relative hidden lg:block">
    <div className="relative rounded-lg overflow-hidden shadow-2xl">
      <img
        src={mockData.images.hero}
        alt="Escritório Barros & Durães Advogados"
        className="w-full h-[600px] object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-navy/60 via-transparent to-transparent"></div>

      <div className="absolute bottom-8 left-8 right-8 bg-white/95 backdrop-blur-sm p-6 rounded-lg shadow-xl">
        <div className="flex items-center justify-between">
          <div>
            <div className="text-3xl font-bold text-navy">10+</div>
            <div className="text-sm text-navy/70">Áreas de Atuação</div>
          </div>
          <div className="h-12 w-px bg-navy/20"></div>
          <div>
            <div className="text-3xl font-bold text-navy">100%</div>
            <div className="text-sm text-navy/70">Compromisso</div>
          </div>
          <div className="h-12 w-px bg-navy/20"></div>
          <div>
            <div className="text-3xl font-bold text-gold">2</div>
            <div className="text-sm text-navy/70">Sócias</div>
          </div>
        </div>
      </div>
    </div>

    <div className="absolute -top-6 -right-6 w-24 h-24 bg-gold/20 rounded-full blur-2xl"></div>
    <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-navy/20 rounded-full blur-2xl"></div>
  </div>
);

const Hero = () => {
  return (
    <section id="home" className="relative min-h-screen flex items-center bg-gradient-to-br from-cream via-white to-cream pt-20">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%231a3a52' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v6h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="space-y-4">
              <div className="inline-block">
                <span className="text-gold font-semibold text-sm uppercase tracking-wider bg-gold/10 px-4 py-2 rounded-sm">
                  Escritório de Advogados
                </span>
              </div>
              <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl font-bold text-navy leading-tight">
                {mockData.company.tagline.split(',')[0]},
                <span className="block text-gold mt-2">
                  {mockData.company.tagline.split(',')[1]}
                </span>
              </h1>
              <p className="text-lg md:text-xl text-navy/70 leading-relaxed max-w-xl">
                {mockData.company.description}
              </p>
            </div>

            <HeroActions />
            <HeroFeatures />
          </div>

          <HeroImage />
        </div>
      </div>
    </section>
  );
};

export default Hero;
